import React from 'react';
import { Box, Grid } from '@mui/material';
import { TableRow } from '@mui/material';
import { TableCell } from '@mui/material';
import { Table } from '@mui/material';
import { getTipoSangre } from '../../../../widgets/fields/TiposSangreField';
import CodeQrComponent from '../../../usuario/usu_entidades/components/code_qr';

const DetalleExpandeFamiliares = ({ data }) => {
  return (
    data && (
      <Box sx={{ width: '100%' }}>
        <Grid container spacing={2} sx={{ p: 1 }}>
          <Grid item xs={12} md={2}>
            <CodeQrComponent
              size={50}
              maxWidth="140px"
              value={`${data.usuario.id}`}
            />
          </Grid>
          <Grid item xs={12} md={9}>
            <Table width="100%">
              <TableRow>
                <TableCell>
                  <strong>Fecha de nacimiento:</strong>
                  <br />
                  {data.usuario.perfil.fechaNacimiento}
                </TableCell>
                <TableCell>
                  <strong>Tipo de sangre:</strong>
                  <br />
                  {getTipoSangre(data.usuario.perfil.tipoSangre)}
                </TableCell>
                <TableCell>
                  <strong>Tiene internet:</strong>
                  <br />
                  {data.usuario.perfil.internet ? 'Si' : 'No'}
                </TableCell>
              </TableRow>
            </Table>
          </Grid>
        </Grid>
      </Box>
    )
  );
};

export default DetalleExpandeFamiliares;
